// extracted by mini-css-extract-plugin
export default {"root":"ConfirmPortfolioActivation_root__NSbie"};